import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';

export interface ConfirmData {
  title: Observable<string>;
  content: Observable<string>;
  yes?: Observable<string>;
  no: Observable<string>;
}

@Component({
  selector: 'app-confirm-dialog',
  template: `
    <mat-card class="mat-elevation-z0">
      <mat-card-title>{{ data?.title | async }}</mat-card-title>
      <mat-card-content class="content">
        {{ data?.content | async }}
      </mat-card-content>
      <mat-card-actions align="end">
        <button mat-button [matDialogClose]="false">{{ data?.no | async }}</button>
        <button mat-button [matDialogClose]="true" color="primary" *ngIf="data?.yes" cdkFocusRegionstart
                cdkFocusInitialTab>{{ data.yes | async }}</button>
      </mat-card-actions>
    </mat-card>
  `,
  styleUrls: [ './confirm.component.scss' ]
})
export class ConfirmComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmData) {
  }

}
